import React, { useState } from "react";
import { Field } from "formik";
import Popup from "../popup/Popup";
import { POPUP_FORM_CONTENT_CLASS, ACTION_POPUP_CONTENT_INNER_CLASS } from "../popup/popupLayoutSpec";
import { AccountPopupField, AccountPopupSaveFooter } from "./accountPopupFields";

const SocialMediaPopup = ({ isOpen, onClose, setFieldValue, values = {}, errors = {}, initialStep = 0 }) => {
  const [currentStep] = useState(initialStep);

  const displayValues = {
    facebookPage: values.facebookPage || "",
    instagram: values.instagram || "",
    linkedinCompany: values.linkedinCompany || "",
    twitter: values.twitter || "",
    tiktok: values.tiktok || "",
    youtube: values.youtube || "",
    pinterest: values.pinterest || "",
  };

  const steps = [
    { title: "Facebook", field: "facebookPage", placeholder: "https://www.facebook.com/acmeplumbing", inputType: "url" },
    { title: "Instagram", field: "instagram", placeholder: "https://www.instagram.com/acmeplumbing", inputType: "url" },
    { title: "LinkedIn", field: "linkedinCompany", placeholder: "https://www.linkedin.com/company/acme-plumbing", inputType: "url" },
    { title: "X (Twitter)", field: "twitter", placeholder: "https://x.com/acmeplumbing", inputType: "url" },
    { title: "TikTok", field: "tiktok", placeholder: "https://www.tiktok.com/@acmeplumbing", inputType: "url" },
    { title: "YouTube", field: "youtube", placeholder: "https://www.youtube.com/@acmeplumbing", inputType: "url" },
    { title: "Pinterest", field: "pinterest", placeholder: "https://www.pinterest.com/acmeplumbing/", inputType: "url" },
  ];

  const currentStepData = steps[currentStep];

  if (!isOpen) return null;

  return (
    <Popup
      setTrigger={() => {}}
      ShowCrossButton={true}
      cross={true}
      onClose={onClose}
      businessDashboard={true}
      hideLogoInHeader={true}
    >
      <div
        className="overflow-auto relative flex items-center justify-center"
        style={{ minHeight: "calc(100vh - 120px)" }}
      >
        <div className={POPUP_FORM_CONTENT_CLASS}>
          <div className={ACTION_POPUP_CONTENT_INNER_CLASS}>
            <form onSubmit={(e) => e.preventDefault()}>
              <Field name={currentStepData.field}>
                {({ form }) => (
                  <AccountPopupField
                    step={{ ...currentStepData, type: "text" }}
                    fieldKey={currentStepData.field}
                    value={displayValues[currentStepData.field]}
                    onChange={(v) => setFieldValue(currentStepData.field, v)}
                    form={form}
                  />
                )}
              </Field>
              <AccountPopupSaveFooter onClick={onClose} />
            </form>
          </div>
        </div>
      </div>
    </Popup>
  );
};

export default SocialMediaPopup;
